/* The partner page's one moment: the floss runs out of the AutoFlosser along
   the line you sign on, to the button. Drawn is the default; the script only
   rewinds it once it knows it can play it back. */
(function () {
  if (window.__afptLoaded) return;
  window.__afptLoaded = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var go = function () {
    var passes = document.querySelectorAll('[data-afpt-pass]');
    if (!passes.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        requestAnimationFrame(function () { e.target.classList.add('is-in'); });
      });
    }, { threshold: 0.4 });
    passes.forEach(function (p) {
      p.classList.add('is-armed');
      void p.getBoundingClientRect();
      io.observe(p);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
})();
